/* DefaultColumnRenderer.js */

"use strict";

const _ = require('lodash');

class DefaultColumnRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("default-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown(){
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._textField = undefined;
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }
    _registerListeners(){
        this._model.on("Value",this._onValue = this._onValue.bind(this));
        this._model.on("Tooltip",this._onTooltip = this._onTooltip.bind(this));
    }
    _unregisterListeners(){
        this._model.removeListener("Value",this._onValue);
        this._model.removeListener("Tooltip",this._onTooltip);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render(){
        let prom = new Promise((resolve/*,reject*/) => {
            this._setValue(this._model.getValue());
            this._setTooltip(this._model.getTooltip());
            resolve();
        });
        return prom;
    }
    get rootElement(){
        return this.getRootElement();
    }
    getRootElement(){
        return this._rootElem;
    }
    get model(){
        return this.getModel();
    }
    getModel(){
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /**
     * Fired when the value has been updated in the model
     * @param newVal {String}
     * @private
     */
    _onValue(newVal){
        this._setValue(newVal);
    }

    /**
     * Fired when the tooltip has been updated in the model
     * @param newVal {String}
     * @private
     */
    _onTooltip(newVal){
        this._setTooltip(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    /**
     * Toggle the display text value of the button
     * @param newVal {String}
     * @private
     */
    _setValue(newVal){
        if (_.isUndefined(newVal)) {
            this._rootElem.innerHTML = '';
        } else {
            this._rootElem.innerHTML = newVal;
        }
    }

    /**
     * Create/Remove the tooltip for the column
     * @param newVal {String}
     * @private
     */
    _setTooltip(newVal){
        if (!_.isUndefined(newVal)) {
            this._rootElem.title = _.escape(newVal);
        } else {
            this._rootElem.removeAttribute('title');
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = DefaultColumnRenderer;
